import { render, staticRenderFns } from "./CustomerCreditForList.vue?vue&type=template&id=5b2dc3a3&"
import script from "./CustomerCreditForList.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditForList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports